const data = {
    events:[
        {
            "id": 1,
            "title": "Maryland's colonial charter granted",
            "event": "George Calvert works to secure the charter that will become the Maryland colony. He dies shortly before it is issued to his eldest son, Cecil Calvert.",
            "importantPeopleAssociates": ["George Calvert","Cecil Calvert","King Charles I","Queen Henrietta Maria"],
            "year": 1632,
            "yearSort": 1632,
            "location": "England",
            "broaderLoc":["England"],
            "Source type": "old looking pdf",
            "sourceThumbnail": "tn-timeline-main-1.jpg",
            "affiliatedPrimarySourcesNameAndDescription":"Maryland's Colonial Charter (1632)",
            "affiliatedPrimarySourcesLink": "https://avalon.law.yale.edu/17th_century/ma01.asp",
            "Source image for full view": "timeline_mainevent-1.jpg",
            "topics": "Colonialism, Calvert family",
            "Notes": "cited in film",
            "highlighted":true
            
        },
        {
           "id": 2,
            "title": "Maryland colony established",
            "event": "Two ships, the Ark and the Dove, set sail for the Chesapeake Bay in November 1633 from the Isle of Wight. 140 Catholic and Protestant passengers are sent to establish a colony in Maryland. They land at St. Clements Island in the Chesapeake Bay in 1634.",
            "importantPeopleAssociates": ["Cecil Calvert","Father Andrew White"],
            "year": "1633-1634",
            "yearSort": 1633,
            "location": "Maryland",
            "broaderLoc":["Maryland"],
            "Source type": "painting",
            "sourceThumbnail": "tn-timeline-main-2.jpg",
            "affiliatedPrimarySourcesNameAndDescription":"Painting - The Landing of the Maryland Colonists from the Ark & the Dove, St. Clement's Island, March 25, 1634",
            "affiliatedPrimarySourcesLink": "https://msa.maryland.gov/msa/mdstatehouse/html/shcaucusrm_ark_dove.html",
            "Source image for full view": "timeline_mainevent-2.jpg",
            "topics": "Colonialism",
            "highlighted":true
            
        },
        {
            "id": 3,
            "title": "Leonard Calvert meets with Wannas",
            "event": "Approximately 40 tribes of Indigenous people live in the lands near St. Clements Island. Colonists meet with Wannas the tayac, head chieftain of the Piscataway, to get permission for settlement in order to avoid conflict with the Indigenous people.",
            "importantPeopleAssociates": ["Leonard Calvert","Wannas the Tayac","Henry Fleet"],
            "year": 1634,
            "yearSort": 1634,
            "location": "Maryland",
            "broaderLoc":["Maryland"],
            "Source type": "video",
            "sourceThumbnail": "tn-timeline-main-3.jpg",
            "affiliatedPrimarySourcesNameAndDescription":"<i>Liberty of Conscience: </br> The Founding of Maryland</i>",
            "affiliatedPrimarySourcesLink": "<iframe src=\"https://player.vimeo.com/video/1225677448?h=03b033aacd&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479\" frameborder=\"0\" allow=\"autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share\" referrerpolicy=\"strict-origin-when-cross-origin\" style=\"width:100%;height:100%;\" title=\"Timeline3-SmithAllbright\"></iframe><script src=\"https://player.vimeo.com/api/player.js\"></script>",
            "topics": "Indigenous history, Calvert family",
            "Notes": "cited in the film",
            "highlighted":true,
            
        },
        {
            "id": 4,
            "title": "Leonard Calvert makes a deal with the Yaocomico",
            "event": "In the years that follow, the native people share information with the colonists that is necessary for their survival.",
            "importantPeopleAssociates": ["Leonard Calvert","King Charles I","Cecil Calvert"],
            "year": 1634,
            "yearSort": 1634,
            "location": "Maryland",
            "broaderLoc":["Maryland"],
            "Source type": "drawing",
            "sourceThumbnail": "tn-timeline-main-4.jpg",
            "affiliatedPrimarySourcesNameAndDescription":"Drawings by John White, from America 1585: The Complete Drawings of John White - fishing scene",
            "Source image for full view": "timeline_mainevent-4.jpg",
            "topics": "Indigenous history, Calvert family",
            "highlighted":true,
            "affiliatedPrimarySourcesLink":"https://msa.maryland.gov/msa/speccol/sc2200/sc2221/000017/000003/pdf/d005049a.pdf",
            "Notes": "cited in the film",
        },
        {
            "id": 5,
            "title": "Maryland colony embraces \"liberty of conscience\"",
            "event": "The colony establishes religious toleration between Catholics and Protestants. This decision means that Maryland does not establish an official religion. Cecilius Calvert wants \"freedom of conscience\" to determine individual religious practice.",
            "importantPeopleAssociates": ["Leonard Calvert","Cecil Calvert"],
            "year": 1634,
            "yearSort": 1634,
            "location": "Maryland",
            "broaderLoc":["Maryland"],
            "Source type": "document",
            "sourceThumbnail": "tn-timeline-main-5.jpg",
            "affiliatedPrimarySourcesNameAndDescription":"Lord Baltimore's Instructions to Colonists November 15, 1633",
            "Source image for full view": "timeline_mainevent-5.jpg",
            "topics": "Religious freedom",
            "Notes": "",
            "highlighted":true,
            "affiliatedPrimarySourcesLink":"https://www.loc.gov/resource/gdc.lhbcb-3364a/?sp=135"
        },
        {
            "id": 6,
            "title": "Early reference to slavery in colonial Maryland",
            "event": "Cecil Calvert, Lord Baltimore, pens a letter to the Secretary of Virginia Richard Kemp. In his reply, Kemp makes one of the first documented references to slavery in colonial Maryland. He references Lord Baltimore's desire to buy \"ten negroes.\"",
            "importantPeopleAssociates": ["Cecil Calvert"],
            "year": 1637,
            "yearSort": 1637,
            "location": "England",
            "broaderLoc":["England"],
            "Source type": "document",
            "sourceThumbnail": "tn-timeline-main-6.jpg",
            "affiliatedPrimarySourcesNameAndDescription":"Calvert Papers, vol 1 (Library of Congress), page 149 of the text (153 of the pdf)",
            "Source image for full view": "timeline_mainevent-6.jpg",
            "topics": "Slavery, Calvert family",
            "highlighted":true,
            "affiliatedPrimarySourcesLink":"https://msa.maryland.gov/msa/speccol/sc2200/sc2221/000017/000003/pdf/d005049a.pdf"
            
        },
        {
            "id": 7,
            "title": "Conversion of Native peoples",
            "event": "Father Andrew White, a Catholic priest, works after his arrival in 1634 to convert local Piscataway and Yaocomico people to Catholicism. He also writes a native dictionary, grammar, and catechism. In 1640, he baptizes Kittamaquund, tayac of the Piscataway.",
            "importantPeopleAssociates": ["Father Andrew White"],
            "year": 1640,
            "yearSort": 1640,
            "location": "St. Mary's City, Maryland",
            "broaderLoc":["Maryland"],
            "Source type": "illustration",
            "sourceThumbnail": "tn-timeline-main-7.jpg",
            "affiliatedPrimarySourcesNameAndDescription":"Societas Jesu apostolorum imitatrix",
            "affiliatedPrimarySourcesLink": "https://archive.org/details/societasjesuapos00tann/page/803/mode/1up",
            "Source image for full view": "timeline_mainevent-7.tif",
            "topics": "Indigenous History",
            "highlighted":true,
        },
        {
            "id": 8,
            "title": "Mathias de Sousa serves in the Maryland legislative assembly",
            "event": "Indentured servants help build the Maryland colony under average contracts of 4-5 years. Mathias de Sousa, an indentured servant of African ancestry, is released around 1638 (having arrived with the original settlers). As a free man, he becomes a trader and master of a cargo vessel. In 1642, he serves in the legislative assembly.",
            "importantPeopleAssociates": ["Mathias de Sousa"],
            "year": 1642,
            "yearSort": 1642,
            "location": "Maryland",
            "broaderLoc":["Maryland"],
            "Source type": "video",
            "sourceThumbnail": "tn-timeline-main-8.jpg",
            "affiliatedPrimarySourcesNameAndDescription":"<i>Liberty of Conscience: </br> The Founding of Maryland</i>",
            "affiliatedPrimarySourcesLink": "<iframe src=\"https://player.vimeo.com/video/1225690140?h=e319e71b17&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479\" frameborder=\"0\" allow=\"autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share\" referrerpolicy=\"strict-origin-when-cross-origin\" style=\"width:100%;height:100%;\" title=\"Timeline3-SmithAllbright\"></iframe><script src=\"https://player.vimeo.com/api/player.js\"></script>",
            "topics": "Indentured servants",
            "Notes": "cited in the film",
            "highlighted":true,
        },
        {
            "id": 9,
            "title": "John Elkin found not guilty of killing the Yaocomico chief",
            "event": "John Elkin, a former indentured servant, is put on trial, accused of killing the Yaocomico chief. He is found not guilty of murder because his peers believe that killing a \"pagan\" (non-Christian) is not against the law. Calvert is unhappy with the jury's decision, but they uphold the not guilty verdict. Relations between Native people and the colonists continue to deteriorate as increased settlement and tobacco production threaten Native lands.",
            "importantPeopleAssociates": ["Leonard Calvert"],
            "year": 1642,
            "yearSort": 1642,
            "location": "Maryland",
            "broaderLoc":["Maryland"],
            "sourceThumbnail": "tn-timeline-main-9.jpg",
            "affiliatedPrimarySourcesNameAndDescription":"Court record - Judicial and Testamentary Business of the Provincial Court, 1637-1650",
            "affiliatedPrimarySourcesLink": "https://msa.maryland.gov/megafile/msa/speccol/sc2900/sc2908/000001/000004/html/am4--183.html",
            "Source image for full view": "timeline_mainevent-9.jpg",
            "topics": "Indigenous history",
            "highlighted":true,
        },
        {
            "id": 10,
            "title": "Governor Leonard Calvert tries to purchase seventeen enslaved laborers",
            "event": "Increased tobacco production in the Maryland colony leads to a labor shortage that could not be met by indentured labor. This shortage leads to the increase of African enslaved labor. In 1642, Governor Leonard Calvert unsuccessfully attempts to buy 17 slaves to work on his lands from John Skinner. The sale included \"fourteene negro men-slaves, & three women slaves, of betweene 16, and 26, yeare old able & sound in body & limbs.\"",
            "importantPeopleAssociates": ["Leonard Calvert"],
            "year": 1642,
            "yearSort": 1642,
            "location": "Maryland",
            "broaderLoc":["Maryland"],
            "Source type": "video",
            "sourceThumbnail": "tn-timeline-main-10.jpg",
            "affiliatedPrimarySourcesNameAndDescription":"<i>Liberty of Conscience: </br> The Founding of Maryland</i>",
            "affiliatedPrimarySourcesLink": "<iframe src=\"https://player.vimeo.com/video/1225697659?h=bb6f2eacc7&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479\" frameborder=\"0\" allow=\"autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share\" referrerpolicy=\"strict-origin-when-cross-origin\" style=\"width:100%;height:100%;\" title=\"Timeline3-SmithAllbright\"></iframe><script src=\"https://player.vimeo.com/api/player.js\"></script>",
            "topics": "Slavery, Calvert family",
            "Notes": "cited in the film",
            "highlighted":true,
        },
        {
            "id": 11,
            "title": "Parliamentary forces attack St. Mary's City",
            "event": "St. Mary's City is plundered by Richard Ingle, employed by Parliament, when it refuses to accept the Church of England. The Catholic chapel is burned, and Father Andrew White is arrested and returned to England. The Calverts are forced to flee to Virginia until 1647.",
            "importantPeopleAssociates": ["Leonard Calvert","Richard Ingle"],
            "year": 1645,
            "yearSort": 1645,
            "location": "St. Mary's City, Maryland",
            "broaderLoc":["Maryland"],
            "Source type": "video",
            "sourceThumbnail": "tn-timeline-main-11.jpg",
            "affiliatedPrimarySourcesNameAndDescription":"<i>Liberty of Conscience: </br> The Founding of Maryland</i>",
            "affiliatedPrimarySourcesLink": "<iframe src=\"https://player.vimeo.com/video/1225705606?h=153ca8680a&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479\" frameborder=\"0\" allow=\"autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share\" referrerpolicy=\"strict-origin-when-cross-origin\" style=\"width:100%;height:100%;\" title=\"Timeline3-SmithAllbright\"></iframe><script src=\"https://player.vimeo.com/api/player.js\"></script>",
            "topics": "Religious freedom",
            "Notes": "cited in the film",
            "highlighted":true,
        },
        {
            "id": 12,
            "title": "Margaret Brent sells Calvert lands to pay militiamen",
            "event": "Margaret Brent, executor of Leonard Calvert's will, liquidates some of the Calvert estate to pay the St. Mary's City militiamen. Her decision outrages Lord Baltimore. A year later, Thomas Greene, Maryland's 2nd Proprietary Governor, finds Brent's petition to allow women to vote in the colonies \"preposterous\" and denies her request. She is the first woman to request a vote in the colonies.",
            "importantPeopleAssociates": ["Leonard Calvert","Margaret Brent"],
            "year": 1647,
            "yearSort": 1647,
            "location": "St. Mary's City, Maryland",
            "broaderLoc":["Maryland"],
            "Source type": "video",
            "sourceThumbnail": "tn-timeline-main-12.jpg",
            "affiliatedPrimarySourcesNameAndDescription":"<i>Liberty of Conscience: </br> The Founding of Maryland</i>",
            "affiliatedPrimarySourcesLink": "<iframe src=\"https://player.vimeo.com/video/1225705605?h=27d0a6ecef&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479\" frameborder=\"0\" allow=\"autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share\" referrerpolicy=\"strict-origin-when-cross-origin\" style=\"width:100%;height:100%;\" title=\"Timeline3-SmithAllbright\"></iframe><script src=\"https://player.vimeo.com/api/player.js\"></script>",
            "topics": "Women's rights, Calvert family",
            "Notes": "cited in the film",
            "highlighted":true,
        },
        {
            "id": 13,
            "title": "The Act Concerning Religion is passed",
            "event": "William Stone becomes governor of Maryland. The governor and Maryland Assembly pass the Act Concerning Religion, which grants freedom of religion to all Christian denominations.",
            "importantPeopleAssociates": ["William Stone","Cecil Calvert"],
            "year": 1649,
            "yearSort": 1649,
            "location": "Maryland",
            "broaderLoc":["Maryland"],
            "Source type": "document",
            "sourceThumbnail": "tn-timeline-main-13.jpg",
            "affiliatedPrimarySourcesNameAndDescription":"Maryland Toleration Act (September 21, 1649)",
            "affiliatedPrimarySourcesLink": "https://avalon.law.yale.edu/18th_century/maryland_toleration.asp",
            "Source image for full view": "timeline_mainevent-13.jpg",
            "topics": "Religious freedom",
            "highlighted":true,
        },
        {
            "id": 14,
            "title": "Articles of Peace and Friendship signed",
            "event": "The colony of Maryland and the Susquehannock people sign an agreement in which the Susquehannock cede most of their land to the colonists.  In exchange, they enter into a military alliance with the colonists against northern tribes. ",
            "importantPeopleAssociates": [],
            "year": 1652,
            "yearSort": 1652,
            "location": "Maryland",
            "broaderLoc":["Maryland"],
            "Source type": "document",
            "sourceThumbnail": "tn-timeline-main-14.jpg",
            "affiliatedPrimarySourcesNameAndDescription":"The 1652 Articles of Peace and Friendship",
            "affiliatedPrimarySourcesLink": "https://www.conestogasusquehannocktribe.com/general-5",
            "Source image for full view": "timeline_mainevent-14.jpg",
            "topics": "Indigenous history",
            "highlighted":true,
        },
        {
            "id": 15,
            "title": "John Babtist is the first enslaved person in Maryland to sue for his freedom",
            "event": "John Babtist argues that he should be set free because his original master did not intend for him to be enslaved for life.  Witnesses testify that his indenture was meant to last for a set period of time.  The Court ruled in his favor, and after serving two more years, he was granted freedom. A precedent is set that African Americans can use the courts to seek protection against enslavement.",
            "importantPeopleAssociates": ["John Babtist"],
            "year": 1653,
            "yearSort": 1653,
            "location": "Maryland",
            "broaderLoc":["Maryland"],
            "Source type": "document",
            "sourceThumbnail": "tn-timeline-main-15.jpg",
            "affiliatedPrimarySourcesNameAndDescription":"Proceedings of the Provincial Court, 1658-1662 (volume 41, page 499)",
            "affiliatedPrimarySourcesLink": "https://msa.maryland.gov/megafile/msa/speccol/sc2900/sc2908/000001/000041/html/am41--499.html?utm_source=chatgpt.com",
            "Source image for full view": "timeline_mainevent-15.jpg",
            "topics": "Slavery",
            "highlighted":true,
        },
        {
            "id": 16,
            "title": "Maryland's assembly makes slavery a life-long and inherited condition",
            "event": "In response to growing desires for enslaved labor on Maryland's tobacco plantations, Maryland's Assembly votes that slavery shall be lifelong and that children of slaves will also be enslaved for life.",
            "importantPeopleAssociates": ["Charles Calvert"],
            "year": 1663,
            "yearSort": 1663,
            "location": "Maryland",
            "broaderLoc":["Maryland"],
            "Source type": "video",
            "sourceThumbnail": "tn-timeline-main-16.jpg",
            "affiliatedPrimarySourcesNameAndDescription":"<i>Liberty of Conscience: </br> The Founding of Maryland</i>",
            "affiliatedPrimarySourcesLink": "<iframe src=\"https://player.vimeo.com/video/1225718174?h=d8f881b89a&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479\" frameborder=\"0\" allow=\"autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share\" referrerpolicy=\"strict-origin-when-cross-origin\" style=\"width:100%;height:100%;\" title=\"Timeline3-SmithAllbright\"></iframe><script src=\"https://player.vimeo.com/api/player.js\"></script>",
            "topics": "Slavery, Calvert family",
            "Notes": "cited in the film",
            "highlighted":true,
        },
        {
            "id": 17,
            "title": "Enslavement of Africans is required by law in Maryland",
            "event": "The Maryland General Assembly separates enslaved people from everyone else in the colony. Laws make it clear who will be enslaved in Maryland: (1) \"Negroes\" (meaning people of African descent) and other enslaved people (probably meaning Native Americans) already in Maryland will serve for their entire lives; (2) all children of \"Negroes\" and other enslaved men will be enslaved for life; (3) any free woman who marries an enslaved man will serve her husband's master during her husband's life; (4) children of free women and enslaved men will be enslaved for their entire lives (5) children of free women and enslaved \"Negro\" men born before this law was enacted must serve their father's master until age 30. While other colonies (Massachusetts in 1641, Virginia in 1662) have previously allowed slavery, Maryland was the first colony to require enslavement of Black people by law.",
            "importantPeopleAssociates": [],
            "year": 1664,
            "yearSort": 1664,
            "location": "Maryland",
            "broaderLoc":["Maryland"],
            "Source type": "document",
            "sourceThumbnail": "tn-timeline-main-17.jpg",
            "affiliatedPrimarySourcesNameAndDescription":"\"An Act Concerning Negroes & other Slaues\"",
            "affiliatedPrimarySourcesLink": "https://msa.maryland.gov/megafile/msa/speccol/sc2900/sc2908/000001/000001/am1--533.html",
            "Source image for full view": "timeline_mainevent-17.jpg",
            "topics": "Slavery",
            "highlighted":true,
        },
        {
            "id": 18,
            "title": "Indigenous people leave Maryland",
            "event": "Tribal representatives complain to the Council of Maryland about infringements on their rights and loss of land. Many Indigenous people leave Maryland in search of better conditions elsewhere.",
            "importantPeopleAssociates": [],
            "year": "1680s+",
            "yearSort": 1680,
            "location": "Maryland",
            "broaderLoc":["Maryland"],
            "Source type": "video",
            "sourceThumbnail": "tn-timeline-main-18.jpg",
            "affiliatedPrimarySourcesNameAndDescription":"<i>Liberty of Conscience: </br> The Founding of Maryland</i>",
            "affiliatedPrimarySourcesLink": "<iframe src=\"https://player.vimeo.com/video/1225728743?h=9f3ea3fe34&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479\" frameborder=\"0\" allow=\"autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share\" referrerpolicy=\"strict-origin-when-cross-origin\" style=\"width:100%;height:100%;\" title=\"Timeline3-SmithAllbright\"></iframe><script src=\"https://player.vimeo.com/api/player.js\"></script>",
            "topics": "Indigenous history",
            "Notes": "cited in the film",
            "highlighted":true,
        },
        {
            "id": 19,
            "title": "Slavery expands in Maryland",
            "event": "Following the Glorious Revolution in England, King William makes Sir Lionel Copley the first Royal Governor of Maryland, ending Calvert control. Maryland landowners consolidate their power, and the use of enslaved labor expands during this period. Maryland planters have greater demand for labor, and enslaved Africans replace indentured servants.",
            "importantPeopleAssociates": [],
            "year": 1692,
            "yearSort": 1692,
            "location": "Maryland",
            "broaderLoc":["Maryland"],
            "Source type": "video",
            "sourceThumbnail": "tn-timeline-main-19.jpg",
            "affiliatedPrimarySourcesNameAndDescription":"<i>Liberty of Conscience: </br> The Founding of Maryland</i>",
            "affiliatedPrimarySourcesLink": "<iframe src=\"https://player.vimeo.com/video/1225728744?h=f2b63811da&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479\" frameborder=\"0\" allow=\"autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share\" referrerpolicy=\"strict-origin-when-cross-origin\" style=\"width:100%;height:100%;\" title=\"Timeline3-SmithAllbright\"></iframe><script src=\"https://player.vimeo.com/api/player.js\"></script>",
            "topics": "Slavery, Calvert family",
            "Notes": "cited in the film",
            "highlighted":true,
        },
        {
            "id": 20,
            "title": "\"Liberty of Conscience\" ends in Maryland",
            "event": "Sir Lionel Copley, the Royal Governor, has the legislature pass an act to establish the Church of England as the official religion of Maryland. This ends the \"freedom of conscience\" that had allowed Catholics to freely practice their faith under the rule of the Calvert family.  Under the direction of Governor Francis Nicholson, the capital of Maryland is moved away from St. Mary's City in 1695, further reducing the influence of the Catholic Calvert family.",
            "importantPeopleAssociates": [],
            "year": 1692,
            "yearSort": 1692,
            "location": "Maryland",
            "broaderLoc":["Maryland"],
            "Source type": "video",
            "sourceThumbnail": "tn-timeline-main-20.jpg",
            "affiliatedPrimarySourcesNameAndDescription":"<i>Liberty of Conscience: </br> The Founding of Maryland</i>",
            "affiliatedPrimarySourcesLink": "<iframe src=\"https://player.vimeo.com/video/1225728742?h=f2b4f2df6b&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479\" frameborder=\"0\" allow=\"autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share\" referrerpolicy=\"strict-origin-when-cross-origin\" style=\"width:100%;height:100%;\" title=\"Timeline3-SmithAllbright\"></iframe><script src=\"https://player.vimeo.com/api/player.js\"></script>",
            "topics": "Religious freedom, Calvert Family",
            "Notes": "cited in the film",
            "highlighted":true,
        },
        {
            "id": 101,
            "event": "The Calvert family practices Catholicism. After a visit from governmernt officials, the family is forced to stop the Catholic upbrininging of George and Christopher Calvert.  The family also must report to a commission every month, declare loyalty to the Church of England, and display a Church of England Bible in the home.  George is forced to leave the family home to be taught by a Protestant tutor.",
            "year": 1592,
            "importantPeopleAssociates": ["George Calvert"],
            "yearSort": 1592,
            "location": "Yorkshire, England",
            "broaderLoc":["England"],
            "topics": "Religious freedom, Calvert family",
            "Source type": "Illustration",
            "sourceThumbnail": "tn-timeline-misc-1.jpg",
            "affiliatedPrimarySourcesNameAndDescription":"Lippinscott's The Protestant Reformation in England, 1563",
            "affiliatedPrimarySourcesLink": "https://www.legislation.gov.uk/aosp/1592/8",
            "Source image for full view": "timeline_miscevent-1.jpg"
        },
        {
            "id": 102,
            "event": "Indigenous peoples had long established communities, governments, trade networks, and relationships with the land that would become Maryland. Upon arrival, Europeans encounter over 40 distinct tribes living in the Maryland area.",
            "year": "1600s",
            "yearSort": 1600,
            "location": "Maryland",
            "broaderLoc":["Maryland"],
            "topics": "Indigenous History",
            "Source type": "Illustration",
            "sourceThumbnail": "tn-timeline-misc-2.jpg",
            "affiliatedPrimarySourcesNameAndDescription":" Illustration accompanying Capt. John Smith's \"The Generall Historie of Virginia.\"",
            "affiliatedPrimarySourcesLink": "https://encyclopediavirginia.org/1867hpr-44330843ae7d492/",
            "Source image for full view": "timeline_miscevent-2.jpg"
        },
        {
            "id": 103,
            "event": "Jamestown, a British colony, was founded on the banks of the James River in Virginia.  It became the first permanent English settlement in North America.",
            "year": 1607,
            "yearSort": 1607,
            "location": "Jamestown, Virginia",
            "broaderLoc":["Virginia"],
            "topics": "Colonialism",
            "Source type": "Illustration",
            "sourceThumbnail": "tn-timeline-misc-3.jpg",
            "affiliatedPrimarySourcesNameAndDescription":"Salt marshes along Jamestown Island, Virginia, part of Colonial National Historical Park",
            "Source image for full view": "timeline_miscevent-3.jpg"
        },
        {
            "id": 104,
            "event": "Captain John Smith led to voyages to explore the Chesapeake Bay.  While on his journey, he documented the terrain and locations of native communities.",
            "year": 1608,
            "yearSort": 1608,
            "importantPeopleAssociates": [],
            "location": "Chesapeake Bay region",
            "broaderLoc":["Maryland, Virginia"],
            "topics": "Colonialism",
            "Source type": "map",
            "sourceThumbnail": "tn-timeline-misc-4.jpg",
            "affiliatedPrimarySourcesNameAndDescription":"Captain John Smith's 1612 map of the Chesapeake Bay region.",
            "affiliatedPrimarySourcesLink": "https://www.loc.gov/resource/g3880.ct008919?r=-0.139,0,1.281,0.794,0",
            "Source image for full view": "timeline_miscevent-4.jpg"
        },
        {
            "id": 105,
            "event": "Enslaved Africans, captured in West Africa, were taken from a Portuguese slave ship by English privateers.  They were sold to English colonists in Virginia and became the first Africans in the British colonies in North America.",
            "year": 1619,
            "yearSort": 1619,
            "location": "Virginia",
            "broaderLoc":["Virginia"],
            "topics": "Slavery",
            "Source type": "illustration",
            "sourceThumbnail": "tn-timeline-misc-5.jpg",
            "affiliatedPrimarySourcesNameAndDescription":"A West African King Forging Metal by Father Giovanni Antonio Cavazzi da Montecuccolo, ca. 1667",
            "affiliatedPrimarySourcesLink": "https://encyclopediavirginia.org/1550-56b9d259d50b8ed/",
            "Source image for full view": "timeline_miscevent-5.jpg"
        },

        {
            "id": 106,
            "event": "After deciding to openly practice Catholicism, George Calvert focuses on the colonization of the Americas.  His first colonial venture is known as the Colony of Avalon in Ferryland.  It eventually fails.",
            "importantPeopleAssociates": ["George Calvert"],
            "year": 1621,
            "yearSort": 1621,
            "location": "Ferryland, Newfoundland",
            "broaderLoc":["Ferryland, Newfoundland, Canada"],
            "topics": "Colonialism, Calvert family",
            "Source type": "video",
            "sourceThumbnail": "tn-timeline-misc-6.jpg",
            "affiliatedPrimarySourcesNameAndDescription":"<i>Liberty of Conscience: </br> The Founding of Maryland</i>",
            "affiliatedPrimarySourcesLink": "<iframe src=\"https://player.vimeo.com/video/1225757411?h=7aba0adacd&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479\" frameborder=\"0\" allow=\"autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share\" referrerpolicy=\"strict-origin-when-cross-origin\" style=\"width:100%;height:100%;\" title=\"Timeline-CharlesHamiltonHouston\"></iframe><script src=\"https://player.vimeo.com/api/player.js\"></script>"
        },
        {
            "id": 107,
            "event": "William Claiborne, a member of the Virginia Council, established a trading post on Kent Island. Fur was traded between the Matapeake people and colonists.",
            "importantPeopleAssociates": ["William Claiborne"],
            "year": 1631,
            "yearSort": 1631,
            "location": "Kent Island, Maryland",
            "broaderLoc":["Maryland"],
            "topics": "Colonialism",
            "Source type": "illustration",
            "sourceThumbnail": "tn-timeline-misc-7.jpg",
            "affiliatedPrimarySourcesNameAndDescription":"Woodcut imagining of Claiborne's fortified settlement, Adams",
            "Source image for full view": "timeline_miscevent-7.jpg",
            "affiliatedPrimarySourcesLink": "https://jeffersonpatterson.wordpress.com/2021/10/06/kent-island-and-marylands-turbulent-early-history/"
        },
        {
            "id": 108,
            "event": "First General Assembly (law-making assembly of freemen) meets at St. Mary's City",
            "importantPeopleAssociates": [],
            "year": 1635,
            "yearSort": 1635,
            "location": "St. Mary's City, Maryland",
            "broaderLoc":["Maryland"],
            "topics": "Colonialism",
            "Source type": "photograph",
            "sourceThumbnail": "tn-timeline-misc-8.jpg",
            "affiliatedPrimarySourcesNameAndDescription":"St. Mary's City Historical Marker",
            "Source image for full view": "timeline_miscevent-8.jpg",
            "affiliatedPrimarySourcesLink": "https://www.hmdb.org/m.asp?m=961"
        },
        {
            "id": 109,
            "event": "This bill defined the rights of people living in Maryland. But it did not cover enslaved people.  This suggests that enslaved people did not have the same rights as other people in Maryland. This bill, which never became a law, does not identify enslaved people by a certain skin color.",
            "importantPeopleAssociates": [],
            "year": 1638,
            "yearSort": 1638,
            "location": "Maryland",
            "broaderLoc":["Maryland"],
            "topics": "Slavery",
            "Source type": "document",
            "sourceThumbnail": "tn-timeline-misc-9.jpg",
            "affiliatedPrimarySourcesNameAndDescription":"1638: Act for the Liberties of the People (Maryland)",
            "Source image for full view": "timeline_miscevent-9.jpg",
            "affiliatedPrimarySourcesLink": "https://msa.maryland.gov/megafile/msa/speccol/sc2900/sc2908/000001/000001/pdf/am1--41.pdf"
        },
        {
            "id": 110,
            "event": "The English Civil War was a conflict between Royalists, who supported the divine right of King Charles I, and Parliamentarians, who favored a constitutional monarchy.  The war caused political unrest in the Maryland colony, which led to rebellions and plundering. At the conclusion of the conflict, Charles I was executed and Oliver Cromwell, a devout Protestant, was declared Lord Protector of a new republic, the Commonwealth.",
            "importantPeopleAssociates": ["King Charles I"],
            "year": "1642-1651",
            "yearSort": 1642,
            "location": "England",
            "broaderLoc":["England"],
            "topics": "English history",
            "Source type": "painting",
            "sourceThumbnail": "tn-timeline-misc-10.jpg",
            "affiliatedPrimarySourcesNameAndDescription":"1782 painting Oliver Cromwell Dissolving the Long Parliament by Benjamin West",
            "Source image for full view": "timeline_miscevent-10.jpg",
            "hideMap":true,
        },
        {
            "id": 111,
            "event": "A plantation owner, Simon Overzee, punished Toney, an enslaved Black man, for not working. Toney was tied to a tree and whipped. Next, Overzee poured scolding hot lard on Toney's wounds. Overzee then tied him by the wrists and suspended him in mid-air to dangle for several hours. Toney died later that day. The Court decided that Overzee's brutal actions were legal. He was acquitted or released because of limited proof. No one could prove that he had punished Toney more than he was allowed. This event shows us that the law favored white plantation owners over enslaved Black people.",
            "importantPeopleAssociates": [],
            "year": 1658,
            "yearSort": 1658,
            "location": "Maryland",
            "broaderLoc":["Maryland"],
            "topics": "Slavery",
            "Source type": "document",
            "sourceThumbnail": "tn-timeline-misc-11.jpg",
            "affiliatedPrimarySourcesNameAndDescription":"Proceedings of the Provincial Court, 1658-1662 (volume 41, pages 205 -206)",
            "affiliatedPrimarySourcesLink": "https://msa.maryland.gov/megafile/msa/speccol/sc2900/sc2908/000001/000041/html/am41--205.html",
            "Source image for full view": "timeline_miscevent-11.jpg"
        },
        {
            "id": 112,
            "event": "Maryland law states that no servant can travel more than two miles from his or her master's house without a pass. ",
            "importantPeopleAssociates": [],
            "year": 1662,
            "yearSort": 1662,
            "location": "Maryland",
            "broaderLoc":["Maryland"],
            "topics": "Slavery",
            "Source type": "document",
            "sourceThumbnail": "tn-timeline-misc-12.jpg",
            "affiliatedPrimarySourcesNameAndDescription":"Proceedings of the Provincial Court, 1658-1662 (volume 41, pages 205 -206)",
            "affiliatedPrimarySourcesLink": "https://msa.maryland.gov/megafile/msa/speccol/sc2900/sc2908/000001/000041/html/am41--205.html",
            "Source image for full view": "timeline_miscevent-12.jpg"
        },
        {
            "id": 113,
            "event": "A Maryland law states that any English servant who runs away with \"Negroes or other slaves,\" has to pay a fine to their enslavers. The earliest runaway laws made freedom seekers serve extra time once they were caught.",
            "importantPeopleAssociates": [],
            "year": 1663,
            "yearSort": 1663,
            "location": "Maryland",
            "broaderLoc":["Maryland"],
            "topics": "Slavery",
            "Source type": "photo",
            "sourceThumbnail": "tn-timeline-misc-13.jpg",
            "affiliatedPrimarySourcesNameAndDescription":"\"Enslaved people working in 17th-century Virginia,\" by an unknown artist, 1670",
            "Source image for full view": "timeline_miscevents-13.jpg"
        },
        {
            "id": 114,
            "event": "An agreement between Maryland's government and 12 Eastern Algonkian-speaking peoples is signed.  The agreement establishes land boundaries and allows native people to preserve fishing and hunting rights.  Rules are established governing how native people and colonists will interact with each other.",
            "importantPeopleAssociates": [],
            "year": 1666,
            "yearSort": 1666,
            "location": "Maryland",
            "broaderLoc": ["Washington, D.C."],
            "topics": "Indigenous History",
            "Source type": "document",
            "sourceThumbnail": "tn-timeline-misc-14.jpg",
            "affiliatedPrimarySourcesNameAndDescription":"Colonial-Indigenous Peace & Amity Treaty, Maryland State Archives (MSA)",
            "affiliatedPrimarySourcesLink": "https://mayis.msa.maryland.gov/Pages/images/doc3-page1.jpg",
            "Source image for full view": "timeline_miscevent-14.jpg"
        },
        {
            "id": 115,
            "event": "The Glorious Revolution leads to the peaceful removal of King James II of England, a Catholic, from power.  He is replaced by William III and Mary II, Protestant rulers.  From this pont forward, Brittain is ruled as a constitutional monarchy.",
            "importantPeopleAssociates": [],
            "year": "1688-1689",
            "yearSort": 1688,
            "location": "England",
            "broaderLoc":["England"],
            "topics": "English history",
            "Source type": "photo",
            "sourceThumbnail": "tn-timeline-misc-15.jpg",
            "affiliatedPrimarySourcesNameAndDescription":"Anno 1689. De kroning van Willem III en Maria Stuart",
            "Source image for full view": "timeline_miscevent-15.jpg"
        },
        {
            "id": 116,
            "event": "Maryland's government shifts from a proprietary colony, ruled by the Lord Baltimore, to a royal colony, controlled by the English government (under the rule of King William and Queen Mary).",
            "importantPeopleAssociates": [],
            "year": 1692,
            "yearSort": 1692,
            "location": "England",
            "broaderLoc":["England"],
            "topics": "Colonialism",
            "Source type": "photo",
            "sourceThumbnail": "tn-timeline-misc-16.jpg",
            "affiliatedPrimarySourcesNameAndDescription":"King William III; Queen Mary II by Romeyn de Hooghe, published by Carel Allard, etching with additional letterpress text, 1689 or after",
            "affiliatedPrimarySourcesLink": "https://www.npg.org.uk/collections/search/portrait/mw133002/King-William-III-Queen-Mary-II",
            "Source image for full view": "timeline_miscevent-16.jpg"
        },
        {
            "id": 117,
            "event": "The capital of colonial Maryland was moved from St. Mary's city to Annapolis.",
            "importantPeopleAssociates": [],
            "year": "1694-1695",
            "yearSort": 1694,
            "location": "Maryland",
            "broaderLoc":["Maryland"],
            "topics": "Colonialism",
            "Source type": "illustration",
            "sourceThumbnail": "tn-timeline-misc-17.jpg",
            "affiliatedPrimarySourcesNameAndDescription":"Maryland State Archives, Special Collections, MSA SC 1444",
            "affiliatedPrimarySourcesLink": "https://msa.maryland.gov/msa/stagser/s1259/131/html/hisimages.html",
            "Source image for full view": "timeline_miscevent-17.jpg"
        },
        {
            "id": 118,
            "event": "Maryland law says enslaved people must remain enslaved even if they become Christians. Before this law was enacted, Christians could not be enslaved. Some enslaved people who converted to Christianity were set free. This law makes it harder for an enslaved person to become free.",
            "importantPeopleAssociates": [],
            "year": 1671,
            "yearSort": 1671,
            "location": "Maryland",
            "broaderLoc":["Maryland"],
            "topics": "Slavery",
            "Source type": "photo",
            "sourceThumbnail": "tn-timeline-misc-18.jpg",
            "affiliatedPrimarySourcesNameAndDescription":"An Act for the Encourageing the Importacon of Negros and Slaues into this Province",
            "affiliatedPrimarySourcesLink": "https://msa.maryland.gov/megafile/msa/speccol/sc2900/sc2908/000001/000002/am2--272.html?utm_source=chatgpt.com",
            "Source image for full view": "timeline_event-18.jpg"
        },
        {
            "id": 119,
            "event": "Thomas Hagleton was born in Africa. He lived and worked in England for a while and then came to Maryland. Once in Maryland he signed a contract to work for Thomas Truman. But Hagleton was one of only a few Africans with work contracts or indentures. Most Africans were enslaved for life. When Hagleton's indenture expired, Truman tried to keep him against his will. Hagleton sued him for his freedom. Maryland law still allowed some Black people to be free. ",
            "year": 1676,
            "yearSort": 1676,
            "location": "Maryland",
            "broaderLoc": ["Maryland"],
            "topics": "Slavery",
            "Source type": "image/logo",
            "sourceThumbnail": "tn-timeline-misc-19.jpg",
            "affiliatedPrimarySourcesNameAndDescription":"Archives of Maryland, Volume 0066, Page 0291 - Proceedings of the Provincial Court, 1675-1677",
            "affiliatedPrimarySourcesLink": "https://tmcf.org/about-us/",
            "Source image for full view": "timeline_miscevent_19.jpg"
        },
        {
            "id": 120,
            "event": "More English ships can now bring enslaved people to Maryland. The Governor of Maryland reports that 470 enslaved Africans arrived in the summer of 1698. Another 352 enslaved Africans arrive in Maryland between May and August of 1699.",
            "year": 1698,
            "yearSort": 1698,
            "location": "Maryland",
            "broaderLoc":["Maryland"],
            "topics": "Slavery",
            "Source type": "photograph",
            "sourceThumbnail": "tn-timeline-misc-20.jpg",
            "affiliatedPrimarySourcesNameAndDescription":"The Struggle for Freedom Exhibit at the Brome Quarter, Historic St. Mary's City",
            "affiliatedPrimarySourcesLink": "https://www.hsmcdigshistory.org/exhibits/the-struggle-for-freedom-exhibit-at-the-brome-quarter/",
            "Source image for full view": "timeline_miscevent_20.jpg" 
        },

    ]
    
}

export default data;